/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserUpdateMustChangePasswordsDto
 */
export interface UserUpdateMustChangePasswordsDto {
    /**
     * 
     * @type {string}
     * @memberof UserUpdateMustChangePasswordsDto
     */
    userId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdateMustChangePasswordsDto
     */
    isMustChangePassword?: boolean;
}

/**
 * Check if a given object implements the UserUpdateMustChangePasswordsDto interface.
 */
export function instanceOfUserUpdateMustChangePasswordsDto(value: object): value is UserUpdateMustChangePasswordsDto {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function UserUpdateMustChangePasswordsDtoFromJSON(json: any): UserUpdateMustChangePasswordsDto {
    return UserUpdateMustChangePasswordsDtoFromJSONTyped(json, false);
}

export function UserUpdateMustChangePasswordsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserUpdateMustChangePasswordsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'isMustChangePassword': json['isMustChangePassword'] == null ? undefined : json['isMustChangePassword'],
    };
}

export function UserUpdateMustChangePasswordsDtoToJSON(json: any): UserUpdateMustChangePasswordsDto {
    return UserUpdateMustChangePasswordsDtoToJSONTyped(json, false);
}

export function UserUpdateMustChangePasswordsDtoToJSONTyped(value?: UserUpdateMustChangePasswordsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'isMustChangePassword': value['isMustChangePassword'],
    };
}

